var constants = {
	MEDIA_LIBRARY_URL: "http://localhost:5001",
	MEDIA_LIBRARY_API_TOCKEN: "Xi0QD6vy8nrsTMOpNvpjFvM9Foiu1Cl6Pms7FLKXjyEY1WoON.s6TVW16dLUgQO6JHqZVurCkWzZdhHoA34sLPNn8ZBOzs9719OUkTm6vhpcVc.ip3UWkYUmnudvyZCbh2cT9jcu9cnX6Q9qfT576NlDOU0E2vs7lgJmzQIv5rjg3cYrHRGXn60qimFOXaPeHXwiGyq9",
	RECAPTCHA_KEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
};

var env = "dev"

if (window.location.href.indexOf('.erickson.it') != -1){
	if (window.location.href.indexOf('test-newsletter') != -1){
		env = "test"
		constants.MEDIA_LIBRARY_URL = "https://test-medialibrary.erickson.it"
		constants.RECAPTCHA_KEY = '6LfYFHAaAAAAADTBhsDvWIjOPk1zBAgfgUyd_CbX'
	} else {
		env = "prod"
		constants.MEDIA_LIBRARY_URL = "https://medialibrary.erickson.it"
		constants.RECAPTCHA_KEY = '6LfYFHAaAAAAADTBhsDvWIjOPk1zBAgfgUyd_CbX'
	}
}

export default constants;